// require("./lib/social");
// require("./lib/ads");
// var track = require("./lib/tracking");

require("component-responsive-frame/child");

var qsa = s => Array.prototype.slice.call(document.querySelectorAll(s));

var clickedTab = function(e) {
  if (e) e.preventDefault();
  var id = this.getAttribute("href").replace(/^#/, "");
  var active = document.querySelector(".tabs .active");
  if (active) active.classList.remove("active");
  this.parentElement.classList.add("active");
  qsa(".phase.expanded").forEach(p => p.classList.remove("expanded"));
  qsa(".tab-content").forEach(function(tab) {
    if (tab.id == id) {
      tab.classList.remove("hidden");
      tab.querySelector(".phase").classList.add("expanded");
    } else {
      tab.classList.add("hidden");
    }
  });
}

qsa(".tabs a").forEach(a => a.addEventListener("click", clickedTab));

var first = document.querySelector(".tabs .instruction a");

clickedTab.call(first);

var timing = 300;

var slideUp = function(element, callback) {
  var bounds = element.getBoundingClientRect();
  element.style.maxHeight = `${bounds.height}px`;
  var _ = element.offsetWidth;
  element.style.transition = `max-height ${timing}ms ease-in-out`;
  element.style.maxHeight = `0px`;
  setTimeout(function() {
    element.style.transition = "";
    element.style.maxHeight = "";
    if (callback) callback();
  }, timing);
};

var slideDown = function(element, callback) {
  var bounds = element.getBoundingClientRect();
  element.style.maxHeight = `0px`;
  var _ = element.offsetWidth;
  element.style.transition = `max-height ${timing}ms ease-in-out`;
  element.style.maxHeight = `${bounds.height}px`;
  setTimeout(function() {
    element.style.transition = "";
    element.style.maxHeight = "";
    if (callback) callback();
  }, timing);
}

var clickedPhase = function(e) {
  var phase = this.parentElement;
  qsa(".phase.expanded").filter(el => el !== phase).forEach(function(p) {
    slideUp(p.querySelector("ul"), () => p.classList.remove("expanded"));
  });
  if (phase.classList.contains("expanded")) {
    slideUp(phase.querySelector("ul"), () => phase.classList.remove("expanded"));
  } else {
    phase.classList.add("expanded");
    slideDown(phase.querySelector("ul"));
  }
};

qsa(".tab-content h3").forEach(h3 => h3.addEventListener("click", clickedPhase));